import { Box } from "@mui/material";
import {
	Datagrid,
	DateField,
	ExportButton,
	FilterButton,
	List,
	ReferenceField,
	SelectInput,
	TextField,
	TextInput,
	TopToolbar,
	useRecordContext,
} from "react-admin";

const partnerEarningFilters = [
	<TextInput key="appId" label="App ID" source="appId" />,
	<TextInput key="partnerId" label="Partner ID" source="partnerId" />,
	<TextInput key="installId" label="Install ID" source="installId" />,
	<TextInput key="payoutId" label="Payout ID" source="payoutId" />,
	<SelectInput
		key="status"
		label="Status"
		source="status"
		alwaysOn
		choices={[
			{ id: "accrued", name: "Accrued" },
			{ id: "processing", name: "Processing" },
			{ id: "unpayable", name: "Unpayable" },
			{ id: "void", name: "Void" },
			{ id: "paid", name: "Paid" },
		]}
	/>,
];

const ListActions = () => (
	<TopToolbar>
		<FilterButton />
		<ExportButton />
	</TopToolbar>
);

const StatusChip = () => {
	const record = useRecordContext();
	if (!record) return null;

	const colors: Record<string, string> = {
		accrued: "#2196f3",
		processing: "#ff9800",
		unpayable: "#9e9e9e",
		void: "#f44336",
		paid: "#4caf50",
	};

	return (
		<Box
			sx={{
				display: "inline-block",
				px: 1,
				py: 0.5,
				borderRadius: 1,
				backgroundColor: colors[record.status] || "#757575",
				color: "white",
				fontSize: "0.75rem",
				fontWeight: 500,
				textTransform: "uppercase",
			}}
		>
			{record.status}
		</Box>
	);
};

const AmountField = () => {
	const record = useRecordContext();
	if (!record) return null;
	return <span>${(record.amountCentsUSD / 100).toFixed(2)} USD</span>;
};

export const PartnerEarningList = () => (
	<List
		filters={partnerEarningFilters}
		actions={<ListActions />}
		sort={{ field: "createdAt", order: "DESC" }}
	>
		<Datagrid bulkActionButtons={false}>
			<DateField source="createdAt" label="Created" showTime />
			<StatusChip />
			<AmountField />
			<ReferenceField source="appId" reference="apps" label="App" link="show">
				<TextField source="name" />
			</ReferenceField>
			<ReferenceField
				source="partnerId"
				reference="partners"
				label="Partner"
				link="show"
			>
				<TextField source="name" />
			</ReferenceField>
			<TextField source="installId" label="Install ID" />
			<TextField source="transactionId" label="Transaction ID" />
			<ReferenceField
				source="payoutId"
				reference="partner-payouts"
				label="Payout"
				link="show"
				emptyText="-"
			>
				<TextField source="id" />
			</ReferenceField>
		</Datagrid>
	</List>
);
